// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price__container[data-v-090533d5]{display:flex}.price__container .price--sale[data-v-090533d5]{display:none}.price__container--sale .price--regular[data-v-090533d5]{text-decoration:line-through;color:#8c8c8c;font-size:18px}.price__container--sale .price--sale[data-v-090533d5]{display:inline-block}", ""]);
// Exports
module.exports = exports;
